export default {
  GET_TOOLBAR: "toolbar/GET_TOOLBAR",
  SET_TOOLBAR: "toolbar/SET_TOOLBAR",
  UPDATE_TOOLBAR: "toolbar/UPDATE_TOOLBAR"
};
